import { VueModule } from '@Foundation/utilities';
import DdxWidget from './code/Scripts/components/ddx.vue';

export default VueModule({
    components: {
        DdxWidget
    }
})